import { useState, useEffect } from "react";
import VariableTextCell from "./VariableTextCell";
import CheckStyleThreshold from "../hooks/checkStyleThreshold";
import Draggable from "./Draggable";

function ProjectController({
  projectTitle,
  projectYears,
  onProjectChange,
  exiting,
}) {
  const [projectYearsString, setProjectYearsString] = useState("");
  const [animationClass, setAnimationClass] = useState("enter");
  const [underStyleThreshold, setUnderStyleThreshold] = useState(null);
  const [beep, setBeep] = useState(true);

  useEffect(() => {
    let yearsString = " (" + projectYears.start;

    if (projectYears.end) {
      yearsString += " — " + projectYears.end;
    }

    yearsString += ")";

    //setProjectYearsString(yearsString);
    setProjectYearsString('');

    setBeep((prev) => !prev);
  }, [projectYears, projectTitle]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (exiting) {
      setAnimationClass("exit");
    } else {
      setAnimationClass("enter");
      setBeep((prev) => !prev);
    }
  }, [exiting]);

  const handleResize = () => {
    setUnderStyleThreshold(CheckStyleThreshold());
  };

  const handleProjectChange = (isNext) => {
    if (!projectTitle) return;
    onProjectChange(isNext);
  };

  return (
    <>
      <button
        onClick={() => handleProjectChange(false)}
        id="project_controller_previous"
        className="button cell"
      >
        <VariableTextCell text="<" minFontSize={1} maxFontSize={2000} beep={beep}/>
      </button>
      <VariableTextCell
        divID="project_controller_name"
        divClasses={`cell ${animationClass}`}
        text={projectTitle ? projectTitle + projectYearsString : "Loading"}
        minFontSize={1}
        maxFontSize={2000}
      />
      <button
        onClick={() => handleProjectChange(true)}
        id="project_controller_next"
        className="button cell"
      >
        <VariableTextCell text=">" minFontSize={1} maxFontSize={2000} />
      </button>
      {Array.from({ length: 2 }, (_, index) => (
        <Draggable key={index}></Draggable>
      ))}
    </>
  );
}

export default ProjectController;
